import * as React from 'react';
import { EmptyBox } from '@/components/common';
import { Button } from '@/components/common';
import AppRoutes from '@/const/routes';

export const InboxEmptyState: React.FC = () => {
	return (
		<div className="flex flex-col justify-center items-center h-full">
			<EmptyBox className="!h-fit" message="The inbox is empty." />
			<Button
				size="fit"
				decoration="secondary"
				label="Explore All Cases"
				href={AppRoutes.CLIENTAPP_ALL_CASES}
				className="!bg-white !w-fit mx-auto"
			/>
		</div>
	);
};
